"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATH_TRANSLATIONS = void 0;
const int_1 = require("./int");
const numberValue_1 = require("./numberValue");
const round_1 = require("./round");
const roundDown_1 = require("./roundDown");
const roundUp_1 = require("./roundUp");
const max_1 = require("./max");
const min_1 = require("./min");
const average_1 = require("./average");
exports.MATH_TRANSLATIONS = {
    INT: int_1.INT,
    NUMBERVALUE: numberValue_1.NUMBERVALUE,
    ROUND: round_1.ROUND,
    ROUNDUP: roundUp_1.ROUNDUP,
    ROUNDDOWN: roundDown_1.ROUNDDOWN,
    MAX: max_1.MAX,
    MIN: min_1.MIN,
    AVERAGE: average_1.AVERAGE,
};
